import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CREATE_MYCAR_VALET_STORE_NAME, CreateMycarValetState } from './create-mycar-valet.state';

/** Select CreateMycarValet State */
export const selectCreateMycarValetState = createFeatureSelector<CreateMycarValetState>(CREATE_MYCAR_VALET_STORE_NAME);

/** Select CreateMycarValet isPending status */
export const selectCreateMycarValetIsPendingStatus = createSelector(
  selectCreateMycarValetState,
  (state) => !!state.isPending
);

/** Select CreateMycarValet isFailure status */
export const selectCreateMycarValetIsFailureStatus = createSelector(
  selectCreateMycarValetState,
  (state) => !!state.isFailure
);
